import { matching as en_matching } from "../en/matching";

/** matching — ES slice (71 keys). */
export const matching: Record<keyof typeof en_matching, string> = {
  location_disabled_title: "Conexión no disponible",
  location_disabled_description:
    "Para usar {name}, activa el uso de tu ubicación para que podamos mostrarte quién está cerca.",
  location_disabled_hint:
    "Ve a Ajustes -> {name} -> Ubicación -> Permitir mientras usas la app",
  location_disabled_button: "Abrir ajustes",
  matching_no_potential_matches_title: "¡Vaya!",
  matching_no_potential_matches_description:
    "Ya no encontramos gente cerca de ti, inténtalo de nuevo más tarde",
  matching_no_potential_matches_button: "Reintentar",
  matching_loading_matches_title: "Buscando el match perfecto...",
  matching_loading_matches_description:
    "Un momento — estamos revisando perfiles para encontrar las mejores conexiones para ti. No tardará mucho.",
  matching_matched_title: "¡Es un match!",
  matching_matched_user_title: "¡Hiciste linq con {name}! ",
  matching_matched_user_button: "Elige tu lugar para verse",
  matching_pick_location_button: "Elige un punto de encuentro",
  match_location_new_matches: "NUEVOS MATCHES ({count})",
  match_location_pick: "Elegir lugar",
  match_location_your_turn: "Tu turno",
  match_location_waiting_short: "Esperando",
  match_location_pick_spot_title: "Elige un lugar para ver a {name}",
  match_location_popular_spots: "LUGARES POPULARES CERCA",
  match_location_proposed_spots: "LUGARES PROPUESTOS",
  match_location_suggest_different: "Sugerir otro lugar",
  match_location_enter_custom: "Escribir ubicación personalizada",
  match_location_your_pick: "TÚ",
  match_location_their_pick: "{name}",
  match_location_waiting: "Esperando a que {name} elija...",
  match_location_different_picks: "¡Elecciones distintas!",
  match_location_different_picks_hint: "¡Elige el mismo lugar para coincidir!",
  match_location_accept_their_spot: "Aceptar su lugar",
  match_location_change_pick: "Cambiar mi elección",
  match_location_select: "Seleccionar",
  match_location_confirm: "Confirmar ubicación",
  match_location_confirmed_title: "¡Es un match!",
  match_location_confirmed_subtitle: "Tú y {name} eligieron",
  match_location_start_chatting: "Empezar a chatear",
  match_location_meeting_at: "Se verán en {name}",
  match_location_navigate: "Cómo llegar",
  match_location_search_placeholder: "Busca un lugar...",
  match_location_category_cafe: "Cafetería",
  match_location_category_restaurant: "Restaurante",
  match_location_category_park: "Parque",
  match_location_category_bar: "Bar",
  match_location_category_museum: "Museo",
  match_location_category_mall: "Centro comercial",
  match_location_category_other: "Otro",
  match_location_distance_mi: "{distance} mi",
  match_location_error_propose: "No se pudo proponer la ubicación",
  match_location_error_load_spots: "No se pudieron cargar los lugares",
  match_location_pick_title: "Elige un lugar para ver a {name}",
  match_location_loading_spots: "Cargando lugares...",
  match_location_no_spots: "No hay lugares disponibles cerca",
  match_location_no_spots_hint: "Prueba a sugerir tu propio lugar abajo",
  match_location_header_title: "Eligiendo lugar",
  match_location_or: "O",
  // --- Tarjeta de encuentro (siempre visible en chats 1:1 de match) ---
  match_location_card_booked: "Reservado ✅",
  match_location_card_pick_spot: "Elige un lugar",
  match_location_card_waiting: "Esperando a {name}",
  match_location_card_your_turn: "Tu turno",
  match_location_card_different_picks: "Lugares distintos",
  match_location_card_no_spot_yet: "Sin lugar aún",
  match_location_card_closed: "Match cerrado",
  match_location_no_events_nearby: "No hay eventos cerca",
  match_location_no_events_nearby_hint: "Inténtalo más tarde",
  match_location_awaiting_decision: "¿Qué tal tu encuentro con {name}?",
  match_location_awaiting_decision_pill: "Decide primero",
  match_location_you_picked: "Elegiste {event}",
  match_location_they_picked: "{name} eligió {event}",
  match_location_default_name: "Tu match",
  match_location_default_title: "Lugar de encuentro",
  match_location_change_spot: "Cambiar lugar",
  match_location_unmatched_message: "Este match está cerrado.",
  match_location_unmatched_subtitle:
    "Puedes conservar la conversación, pero este encuentro terminó.",
  match_location_suggest_place: "Sugerir otro lugar",
  match_location_custom_instructions:
    "Escribe un lugar donde te gustaría verse. Incluye el nombre y la dirección para que tu match pueda encontrarlo.",
  match_location_name_label: "Nombre del lugar",
  match_location_name_placeholder: "p. ej., Parque Central, Mi café favorito",
  match_location_address_label: "Dirección (opcional)",
  match_location_address_placeholder: "p. ej., Calle Principal 123",
  match_location_use_current: "Usar mi ubicación actual",
  match_location_coordinates_set: "Coordenadas de ubicación establecidas",
  match_location_preview: "Tu sugerencia",
  match_location_confirm_location: "Confirmar ubicación",
  match_location_permission_denied_title: "Permiso de ubicación",
  match_location_permission_denied_message:
    "Activa los permisos de ubicación en los ajustes de tu dispositivo para usar esta función.",
  match_location_get_location_error: "No se pudo obtener tu ubicación actual",
  match_location_name_required: "Escribe el nombre de un lugar",
  match_location_propose_error:
    "No se pudo sugerir la ubicación. Inténtalo de nuevo.",
  match_location_chat_error: "No se pudo abrir el chat. Inténtalo de nuevo.",
};
